export enum Skin {
    default = 'default',
    cre = 'cre',
    cre_dark = 'cre_dark',
}
